const TICKET_FULL_PRICE = 399;

const ticketOptions = {
    id: 'ingresso',
    name: 'Ingresso CyberSecGO',
    info: '',
    price: TICKET_FULL_PRICE,
};

export default ticketOptions;